import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Grow,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CampaignForm } from "..";

export const CampaignModal = ({ open, onClose, onSubmit, initialData }) => {
  const handleFormSubmit = (result) => {
    if (onSubmit) {
      onSubmit(result);
    } else {
      onClose();
    }
  };

  const handleFormCancel = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        onClose();
      }}
      maxWidth="sm" // Opciones: xs, sm, md, lg, xl
      fullWidth
      TransitionComponent={Grow}
      transitionDuration={500}
      PaperProps={{
        sx: {
          borderRadius: 2,
          marginTop: 10,
        },
        style: {
          zIndex: 1600,
        },
      }}
    >
      <DialogTitle
        component="div"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
          pt: 0.5,
        }}
      >
        
        <Typography variant="h3" sx={{py: 2}}>{initialData ? `Clonar: ${initialData.campaignName}` : 'Crear Campaña'}</Typography>
       

        <IconButton
          aria-label="cerrar"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: (theme) => theme.palette.grey[700],
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          pt: 1,
          pb: 3,
        }}
      >
        <CampaignForm onSubmit={handleFormSubmit} onCancel={handleFormCancel} initialData={initialData} />
      </DialogContent>
    </Dialog>
  );
};
